export default __webpack_public_path__ + "static/media/card2-edp.2fb38ac9.png";